export default __webpack_public_path__ + "static/media/co10.ddd0311e.png";